import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import style from "../../scss/Dashboard.module.scss";
import MesaTarjetaComponent from "../Resultados/component/MesaTarjetaComponent";
import { getEscrutinios } from "../../Api/ApiEscrutinio";
import { FILTROS_MESA, conMotivos } from "../../utils/problemasMesa";
import { esAdmin } from "../../utils/sesion";
import useAutoRefresco from "../../hooks/useAutoRefresco";

// Lista de mesas escrutadas, filtrada por ?filtro= (escrutadas, abiertas,
// cerradas, problemas, sinFoto). Llega desde los indicadores de Resultados y
// cada tarjeta abre el escrutinio de esa mesa.
const MesasPages = () => {
  const [parametros, setParametros] = useSearchParams();
  const [escrutinios, setEscrutinios] = useState([]);
  const [cargando, setCargando] = useState(true);

  const filtroActivo = FILTROS_MESA.find((f) => f.clave === parametros.get("filtro")) ?? FILTROS_MESA[0];
  const lugar = parametros.get("lugar");
  const mesa = parametros.get("mesa");

  const cargar = useCallback(() => {
    getEscrutinios({ lugar, mesa })
      .then((data) => setEscrutinios(data.escrutinios ?? []))
      .catch((error) => console.error(error))
      .finally(() => setCargando(false));
  }, [lugar, mesa]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  useAutoRefresco(cargar);

  const mesas = useMemo(() => conMotivos(escrutinios), [escrutinios]);
  const mesasFiltradas = mesas.filter(filtroActivo.cumple);

  const cambiarFiltro = (clave) => {
    const nuevos = new URLSearchParams(parametros);
    nuevos.set("filtro", clave);
    setParametros(nuevos);
  };

  return (
    <div className={`container ${style.dashboard}`}>
      <div className={style.encabezado}>
        <div>
          <Link to="/resultado" className={style.volver}>
            <Icon icon="mdi:arrow-left" aria-hidden="true" /> Volver a resultados
          </Link>
          <h1 className={style.titulo}>Mesas escrutadas</h1>
          <p className={style.descripcion}>
            {lugar || mesa
              ? `Filtrado por ${[lugar, mesa && `mesa ${mesa}`].filter(Boolean).join(" · ")}`
              : "Todas las mesas"}{" "}
            · toca una mesa para abrir su escrutinio
          </p>
        </div>
        {!esAdmin() && <p className={style.aviso}>Solo se muestran las mesas que tú registraste.</p>}
      </div>

      <div className={style.pestanas} role="tablist" aria-label="Filtrar mesas">
        {FILTROS_MESA.map((filtro) => {
          const activo = filtro.clave === filtroActivo.clave;
          return (
            <button
              key={filtro.clave}
              type="button"
              role="tab"
              aria-selected={activo}
              className={`${style.pestana} ${activo ? style.pestanaActiva : ""}`}
              onClick={() => cambiarFiltro(filtro.clave)}
            >
              {filtro.etiqueta}
              <span className={style.pestanaContador}>{mesas.filter(filtro.cumple).length}</span>
            </button>
          );
        })}
      </div>

      <section className={style.panel} aria-label={`Mesas: ${filtroActivo.etiqueta}`}>
        {cargando ? (
          <p className={style.vacio}>
            <span className="spinner-border spinner-border-sm" aria-hidden="true" /> Cargando mesas…
          </p>
        ) : mesasFiltradas.length === 0 ? (
          <p className={style.vacio}>
            <Icon icon="mdi:table-off" aria-hidden="true" /> No hay mesas en «{filtroActivo.etiqueta.toLowerCase()}».
          </p>
        ) : (
          <ul className={style.mesas}>
            {mesasFiltradas.map((item) => (
              <li key={item.id}>
                <MesaTarjetaComponent mesa={item} />
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
};

export default MesasPages;
